fragment McfxAudienceFragment on McfxApiAudience {
    externalId
    name
    category
    size
}
